
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import virtualList from 'vue-virtual-scroll-list';
import BulkEditFields from '@/modules/BulkEdit/BulkEditFields.vue';

@Component({
  components: {
    BulkEditFields,
    virtualList,
  },
})

export default class BulkEdit extends Vue {
  @Prop()
    editSelected!: IBulkResponse;

    selectedKeys: IFieldsData[] = [];
    editableData: any[] = [];
    showSelectFields: boolean = false;

  selectedFieldsChange(fields: IFieldsData[]) {
    this.showSelectFields = false;
    this.selectedKeys = fields;
  }

  checkIfSelected(field: IFieldsData) {
    if (field) {
      for (const iterator of this.selectedKeys) {
        if (iterator.name === field.name) {
          return true;
        }
      }
      return false;
    }
  }

  save() {
    console.log('change');

    // return new Promise((resolve, reject) => {
    //   axios.patch(`/protected/modules/${localStorage.getItem('module')}/bulk`,)
    // })
  }

  cancel() {
    console.log('zbrisal');

    this.$emit('cancel');
  }
  /**
   * Called when changes need to re-render
   */
  mounted() {
    this.editableData = this.editSelected.data;
  }
}
